/* MXDVS depth scroll bar, option B3 (notch thumb). Approved 09.10.2026.
   Homepage collections and collection pages only (rendered from layout/theme.liquid).
   - 0 mm starts at the top of #MainContent (on the homepage: right under the hero video).
   - The bar is clipped out of the hero video and the footer with transforms only.
   - Tape and counter move 1:1 with the page; the notch thumb shows the position and can be dragged.
   - v2 (09.10.2026): counter 11px on desktop, 9px on phones (digit step follows the screen size).
   - v3 (09.10.2026): phones get a white copy of the ruler on top of the content, cut out to the product photos
     and the video only (clip-path), so the ruler reads white over the images and stays grey everywhere else.
   - v5 (09.10.2026): the white cut-out over the video and photos also runs on desktop.
   - v6 (09.10.2026): speed: photo and video positions are measured once (and again only when the page or a rail
     changes), not on every frame; the white outline is only rewritten when it actually changes.
   - v4 (09.10.2026): grey is black at 15%; ruler opacity 35% while scrolling, 14% when idle (stylesheet).
   - One passive scroll listener, one write per frame, nothing runs while the page stands still. */
(function () {
  var back = document.querySelector('.mx-depth'), top = document.querySelector('.mx-depth-top');
  if (!back || !top) return;

  var c = { color: 'rgba(0,0,0,0.15)', numColor: 'rgba(0,0,0,0.15)', white: '#ffffff', width: 17.5, every: 100, minor: 1,
            fade: true, delay: 1200, fixed: 9 };
  var PX = 96 / 25.4, w = c.width, ev = c.every, DH = 14, T = 10 * PX, i, dg = '';
  for (i = 0; i < 4; i++) dg += '<span class="dg"><b>0<br>1<br>2<br>3<br>4<br>5<br>6<br>7<br>8<br>9<br>0</b></span>';
  function wrap(html) { return '<div class="mxa"><div class="mxb"><div class="mxc">' + html + '</div></div></div>'; }
  var ruler = wrap('<div class="tkw"><i class="tk"></i></div><i class="lb"></i><div class="ixw"><i class="ix"></i><span class="cw">' + dg + '<span class="u">mm</span></span></div>');

  /* white copy, placed between the grey ruler and the notch */
  var white = document.createElement('div');
  white.className = 'mx-depth mx-depth-w';
  white.setAttribute('aria-hidden', 'true');
  top.parentNode.insertBefore(white, top);

  var rulers = [back, white], tints = [c.color, c.white];
  rulers.forEach(function (r) { r.innerHTML = ruler; });
  top.innerHTML = wrap('<i class="tr"></i><i class="th"></i><b class="hit"></b>');
  document.documentElement.classList.add('mx-depth-on');

  function all(sel) { return rulers.map(function (r) { return r.querySelector(sel); }); }
  var TK = all('.tk'), LB = all('.lb'), th = top.querySelector('.th'), hit = top.querySelector('.hit');
  var D = rulers.map(function (r) { return [].slice.call(r.querySelectorAll('.dg b')); });
  var layers = rulers.concat(top);
  var A = layers.map(function (l) { return l.querySelector('.mxa'); }),
      B = layers.map(function (l) { return l.querySelector('.mxb'); }),
      C = layers.map(function (l) { return l.querySelector('.mxc'); });
  var main = document.getElementById('MainContent'), foot = document.querySelector('.shopify-section-group-footer-group');
  var st = 0, fb = 1, en = 1, V = 1, thH = c.fixed, last = -1, busy = false, lbBase = null, idleT = 0, drag = false, H = 0, grab = 0;

  function grad(col, step, len) { return 'repeating-linear-gradient(to bottom,' + col + ' 0 1px,transparent 1px ' + step + 'px) right top/' + (w * len) + 'px 100% no-repeat'; }
  function docTop(el) { return el.getBoundingClientRect().top + window.scrollY; }

  var phone = window.matchMedia('(max-width: 749px)'), MEDIA = [], RECTS = [], lastClip = '';
  /* photo and video positions on the page, kept only for the ones that reach the ruler strip on the right */
  function measureMedia() {
    var W = window.innerWidth, x0 = W - (w + 70), sy = window.scrollY;
    RECTS = [];
    for (var m = 0; m < MEDIA.length; m++) {
      var r = MEDIA[m].getBoundingClientRect();
      if (r.width === 0 || r.right <= x0) continue;
      RECTS.push([Math.max(r.left, x0), r.top + sy, Math.min(r.right, W), r.bottom + sy]);
    }
    last = -1;
  }
  /* show the white ruler only where it crosses a product photo or the video */
  function clipWhite(y) {
    var pts = [], starts = [];
    for (var m = 0; m < RECTS.length; m++) {
      var R = RECTS[m], t = R[1] - y, bb = R[3] - y;
      if (bb <= 0 || t >= V) continue;
      t = Math.max(t, 0); bb = Math.min(bb, V);
      var s0 = R[0] + 'px ' + t + 'px';
      pts.push(s0, R[2] + 'px ' + t + 'px', R[2] + 'px ' + bb + 'px', R[0] + 'px ' + bb + 'px', s0);
      starts.push(s0);
    }
    /* several rectangles in one polygon: walk back over the same joining lines, so they add no area */
    var clip = pts.length ? 'polygon(' + pts.concat(starts.reverse()).join(',') + ')' : 'inset(100%)';
    if (clip !== lastClip) { lastClip = clip; white.style.clipPath = clip; }
  }
  function measure() {
    MEDIA = [].slice.call(document.querySelectorAll('#MainContent .mx-card__media, #MainContent .mx-video__frame'));
    V = window.innerHeight;
    measureMedia();
    DH = phone.matches ? 11 : 14;   /* counter line height: 9px text on phones, 11px on desktop */
    st = main ? docTop(main) : 0;
    fb = foot ? docTop(foot) : document.documentElement.scrollHeight;
    en = Math.max(st + 1, fb - V);
    var Ah = T * Math.ceil(V / T + 1), h = '', K = 2 * Math.ceil(V / (ev * PX)) + 1; H = (K - 1) / 2;
    for (i = 0; i < K; i++) h += '<span style="top:' + ((i - H) * ev * PX).toFixed(2) + 'px"></span>';
    for (var n = 0; n < rulers.length; n++) {
      var col = tints[n];
      TK[n].style.cssText = 'top:50%;margin-top:' + (-Ah) + 'px;height:' + (2 * Ah) + 'px;background:' + grad(col, PX * c.minor, .25) + ',' + grad(col, 5 * PX, .45) + ',' + grad(col, 10 * PX, .7);
      LB[n].innerHTML = h;
    }
    lbBase = null;
    thH = c.fixed > 0 ? c.fixed : Math.max(35, V * V / (en - st + V));
    th.style.height = thH + 'px';
    last = -1; frame();
  }

  function frame() {
    busy = false;
    var y = window.scrollY; if (y === last) return; last = y;
    clipWhite(y);
    /* clip: hide above the hero bottom (a) and below the footer top (b) */
    var a = Math.min(V, Math.max(0, st - y)), b = Math.max(-V, Math.min(0, fb - y - V)), n;
    for (n = 0; n < layers.length; n++) {
      A[n].style.transform = 'translate3d(0,' + a + 'px,0)';
      B[n].style.transform = 'translate3d(0,' + (b - a) + 'px,0)';
      C[n].style.transform = 'translate3d(0,' + (-b) + 'px,0)';
    }
    var d = Math.min(Math.max(y - st, 0), en - st), p = d / (en - st), mm = d / PX, q = Math.floor(mm / ev);
    var newBase = q !== lbBase; lbBase = q;
    for (n = 0; n < rulers.length; n++) {
      TK[n].style.transform = 'translate3d(0,' + (-(d % T)) + 'px,0)';
      if (newBase) {
        var ch = LB[n].children;
        for (var j = 0; j < ch.length; j++) { var v = (q + j - H) * ev; ch[j].textContent = v >= 0 && v * PX <= en - st ? v : ''; }
      }
      LB[n].style.transform = 'translate3d(0,' + (-(d - q * ev * PX)) + 'px,0)';
      for (var k = 0; k < 4; k++) {
        var pw = Math.pow(10, k), o = Math.floor(mm / pw) % 10 + (k ? Math.max(0, mm % pw - (pw - 1)) : mm % 1);
        D[n][3 - k].style.transform = 'translate3d(0,' + (-o * DH) + 'px,0)';
      }
    }
    th.style.transform = 'translate3d(0,' + (p * (V - thH)) + 'px,0)';
    wake();
  }

  function setAll(cls, on) { layers.forEach(function (l) { l.classList[on ? 'add' : 'remove'](cls); }); }
  function wake() {
    setAll('idle', false); clearTimeout(idleT);
    if (c.fade && !drag) idleT = setTimeout(function () { setAll('idle', true); }, c.delay);
  }
  function onScroll() { if (!busy) { busy = true; requestAnimationFrame(frame); } }

  /* drag the notch (or anywhere on the edge strip) to scroll */
  function down(e) {
    drag = true; setAll('active', true);
    var r = top.getBoundingClientRect(), ty = (Math.min(Math.max(window.scrollY - st, 0), en - st) / (en - st)) * (V - thH), yy = e.clientY - r.top;
    grab = (yy >= ty && yy <= ty + thH) ? yy - ty : thH / 2;
    try { hit.setPointerCapture(e.pointerId); } catch (x) {}
    move(e); e.preventDefault();
  }
  function move(e) {
    if (!drag) return;
    var r = top.getBoundingClientRect(), p = Math.min(1, Math.max(0, (e.clientY - r.top - grab) / (V - thH)));
    window.scrollTo(0, st + p * (en - st));
  }
  function up() { if (!drag) return; drag = false; setAll('active', false); wake(); }
  hit.addEventListener('pointerdown', down);
  hit.addEventListener('pointermove', move);
  hit.addEventListener('pointerup', up);
  hit.addEventListener('pointercancel', up);

  window.addEventListener('scroll', onScroll, { passive: true });
  /* a swipe rail (knitwear) moves photos sideways: update the white cut-out */
  var railBusy = false;
  document.addEventListener('scroll', function (e) {
    if (e.target === document || railBusy) return;
    railBusy = true;
    requestAnimationFrame(function () { railBusy = false; measureMedia(); frame(); });
  }, { passive: true, capture: true });
  /* products fade in on the homepage: measure the photos again once they have settled */
  window.addEventListener('load', function () { setTimeout(function () { measureMedia(); frame(); }, 1500); });
  window.addEventListener('resize', measure);
  window.addEventListener('load', measure);
  /* collection "View more" and lazy sections change the page length: measure again only when it changes */
  if (window.ResizeObserver && main) new ResizeObserver(function () { measure(); }).observe(main);
  document.addEventListener('shopify:section:load', measure);
  measure();
})();
